import CONTENT_TYPES from 'config/constants/CONTENT_TYPES';
import general_messages from 'messages/general_messages';

const CONTENT_TYPES_SELECT = [
  { key: CONTENT_TYPES.ARTICLE, label: general_messages.article },
  { key: CONTENT_TYPES.GUIDE, label: general_messages.guide },
];

export default CONTENT_TYPES_SELECT;
